import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import Upload from 'meinian-package/src/component/upload'
import { Dropdown, Ul, Li } from 'meinian-package/src/baseComponent'

export default ({ children, ...props }) => {
  return <Upload {...props}>
    {children}
  </Upload>
}

export const Action = ({ onDeleteItem }) => {
  return <Dropdown
    trigger="hover"
    getPopupContainer={() => document.body}
    overlay={<Ul
      style={{ width: 150 }}
      ulProps={{
        onClick: (e) => {
          e.stopPropagation()
        }
      }}
    >
      <Li className="mn-dropdown-icon-li delete" onClick={onDeleteItem}><Icon type="m-shanchu" />删除</Li>
    </Ul>}
    placement="bottomRight"
    className="mn-image-card-operation"
  >
    <span
      style={{ padding: '4px 6px', borderRadius: 6, backgroundColor: '#fff', border: '1px solid var(--m-fill-3)' }}
    ><Icon type="m-gengduo" /></span>
  </Dropdown>
}
